// JS file for Ethics
